import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { FormTable } from "@/components/FormTable/FormTable";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user/superuser/statistikk/")({
  head: () => ({
    meta: [{ title: "Superuser statistikk | Alice & Bob" }],
  }),
  loader: async () => {
    const res = await routeLoaderApiClient.superuser.reports["successfully-tinglyst-documents"].$get();
    if (res.ok === false) {
      throw new Error("Failed to fetch successfully tinglyst documents statistis");
    }

    const successfullyTinglystDocuments = await res.json();

    return {
      successfullyTinglystDocuments,
    };
  },
  component: Page,
});

function Page() {
  const { successfullyTinglystDocuments } = Route.useLoaderData();

  return (
    <>
      <DocumentTitle>Statistikk</DocumentTitle>

      <div className="u-flow">
        <h1>Dokumenter med status &quot;Tinglyst&quot;</h1>

        <FormTable>
          <table>
            <thead>
              <tr>
                <th>Dokumenttype</th>
                <th>Antall</th>
              </tr>
            </thead>

            <tbody>
              {successfullyTinglystDocuments.map((row) => {
                return (
                  <tr key={row.documentType}>
                    <th>{row.documentType}</th>
                    <td>{row.count}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </FormTable>
      </div>
    </>
  );
}
